<button
  [id]="SCROLL_TOP_BTN_ID"
  color="primary"
  mat-icon-button
  class="position-fixed"
  matTooltip="Voltar para o Topo"
  (click)="scrollTop()"
  role="button"
>
  <mat-icon class="c-white">expand_less</mat-icon>
</button>
